import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import SpinnerComp from '../../components/util/SpinnerComp'
import Modal from 'react-modal'
import {
  addUser,
  deleteUser,
  getUsers,
  updateUser,
} from '../../features/user/userSlice'
// import { resetAuth } from '../../features/auth/authSlice'
// import { resetOrder } from '../../features/order/orderSlice'
// import { resetSetting } from '../../features/setting/settingSlice'
import './Users.css'
import { setToken } from '../../features/auth/authSlice'

const Users = () => {
  // Redux
  const { token } = useSelector((state) => state.auth)
  const { users, userLoading } = useSelector((state) => state.user)

  // Dispatch
  const dispatch = useDispatch(token)

  useEffect(() => {
    if (token) {
      dispatch(getUsers(token))
        .unwrap()
        .then(({ res, newToken }) => {
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        })
        .catch((error) => {})
    }
    // eslint-disable-next-line
  }, [dispatch])

  //   Add user
  const [isAdduser, setIsAdduser] = useState(false)
  const isAdduserToggle = () => {
    setIsAdduser((prev) => !prev)
  }

  const [userIdAdd, setUserIdAdd] = useState('')
  const [userNameAdd, setUserNameAdd] = useState('')
  const [userDepartementAdd, setUserDepartementAdd] = useState('')
  const [userAuthAdd, setUserAuthAdd] = useState('')

  const addUserHandler = (e) => {
    e.preventDefault()
    const data = {
      user_id: userIdAdd,
      user_name: userNameAdd,
      Department: userDepartementAdd,
      Auth: Number(userAuthAdd),
    }
    // console.log(data)
    dispatch(addUser({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === 'success') {
          dispatch(getUsers(token))
          toast.success(res.data.description)
          setIsUserAddSuccess(true)
          setGivenPassword(res.data.value)
          setUserIdAdd('')
          setUserNameAdd('')
          setUserDepartementAdd('')
          setUserAuthAdd('')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {
        const newToken = error.response.headers.authorization
        if (error.response.data.error_message === 'unauthorized') {
          toast.error(error.response.data.error_message)
          if (
            error.response.data.error_message === 'unauthorized' &&
            newToken
          ) {
            dispatch(setToken(newToken))
          }
        }
      })
  }

  //   Edit User
  const [editTarget, setEditTarget] = useState(null)
  //   edit user data
  const [userIdEdit, setUserIdEdit] = useState('')
  const [userNameEdit, setUserNameEdit] = useState('')
  const [userDepartmentEdit, setUserDepartementEdit] = useState('')
  const [userAuthEdit, setUserAuthEdit] = useState('')

  useEffect(() => {
    if (editTarget !== null) {
      setUserIdEdit(editTarget.user_id)
      setUserNameEdit(editTarget.user_name)
      setUserDepartementEdit(editTarget.department)
      setUserAuthEdit(editTarget.auth)
    }
  }, [editTarget])

  const editUserhandler = () => {
    const data = {
      id: editTarget.id,
      user_id: userIdEdit,
      user_name: userNameEdit,
      Department: userDepartmentEdit,
      Auth: Number(userAuthEdit),
    }
    // console.log(data)
    dispatch(updateUser({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === 'success') {
          dispatch(getUsers(token))
          setEditTarget(null)
          toast.success(res.data.description)
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {
        const newToken = error.response.headers.authorization
        if (error.response.data.error_message === 'unauthorized') {
          toast.error(error.response.data.error_message)
          if (
            error.response.data.error_message === 'unauthorized' &&
            newToken
          ) {
            dispatch(setToken(newToken))
          }
        }
      })
  }

  //   cancel edit
  const cancelEditHadnler = () => {
    setEditTarget(null)
    setUserIdEdit('')
    setUserNameEdit('')
    setUserDepartementEdit('')
    setUserAuthEdit('')
  }
  //   console.log(editTarget)

  //   User delete handler
  const [isUserDeleteModal, setIsUserDeleteModal] = useState(false)
  const userDeleteHandler = (id) => {
    // console.log(id)
    const data = {
      id: id,
    }
    dispatch(deleteUser({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === 'success') {
          dispatch(getUsers(token))
          setEditTarget(null)
          toast.success(res.data.description)
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        }
      })
      .catch((error) => {
        const newToken = error.response.headers.authorization
        if (error.response.data.error_message === 'unauthorized') {
          toast.error(error.response.data.error_message)
          if (
            error.response.data.error_message === 'unauthorized' &&
            newToken
          ) {
            dispatch(setToken(newToken))
          }
        }
      })
    setIsUserDeleteModal(false)
  }

  //   Prompt if user add success
  const [givenPassword, setGivenPassword] = useState('')
  const [isUserAddSuccess, setIsUserAddSuccess] = useState(false)
  const closePromtUserAddSuccess = () => {
    setGivenPassword('')
    setIsUserAddSuccess(false)
  }
  if (isUserAddSuccess)
    return (
      <Modal
        isOpen={isUserAddSuccess}
        shouldCloseOnOverlayClick={false}
        onRequestClose={closePromtUserAddSuccess}
        style={customStylesUploadFail}
        contentLabel="Confirm failure"
      >
        <h1 className="font-semibold text-lg">ユーザーの追加</h1>
        <div className="w-full w-12/12 flex flex-col justify-center items-center sm:flex-row gap-2 my-8 overflow-x-auto">
          <p className="text-lg">
            初期パスワードは、<span className="font-bold">{givenPassword}</span>{' '}
            に設定されました。(一度しか表示されません)
          </p>
        </div>

        <div className="flex gap-2 justify-center items-center">
          <button
            onClick={closePromtUserAddSuccess}
            className="min-w-[120px] bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
            type="button"
          >
            OK
          </button>
        </div>
      </Modal>
    )

  if (userLoading) return <SpinnerComp />

  return (
    <div className="w-full mb-8 px-2">
      <h1 className="text-center my-4 text-2xl leading-snug uppercase">
        ユーザーの管理
      </h1>

      {/* Button Add */}
      <div className="flex justify-end">
        <button
          onClick={isAdduserToggle}
          className="px-4 py-[2px] border-[3px] border-orange-500 mt-4 rounded-md"
        >
          ユーザーの追加
        </button>
      </div>
      {/* End Button Add */}

      {/* Add User From */}
      {isAdduser && (
        <form
          onSubmit={addUserHandler}
          className="w-full w-12/12 mt-6 flex flex-col gap-[4px] p-[4px] rounded-[8px] bg-orange-200 border border-gray-800"
        >
          <h1 className="text-center">Add New User</h1>
          <div className="flex flex-col sm:flex-row gap-[4px] text-sm">
            <input
              className="w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800"
              type="email"
              placeholder="E-MAIL"
              value={userIdAdd}
              onChange={(e) => setUserIdAdd(e.target.value)}
              required
            />
            <input
              className="w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800"
              type="text"
              placeholder="名前"
              value={userNameAdd}
              onChange={(e) => setUserNameAdd(e.target.value)}
              required
            />
            <input
              className="w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800"
              type="text"
              placeholder="部門"
              value={userDepartementAdd}
              onChange={(e) => setUserDepartementAdd(e.target.value)}
              required
            />
            <select
              name="auth"
              id="auth"
              className="w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-black"
              onChange={(e) => setUserAuthAdd(e.target.value)}
            >
              <option value="0">スタッフ</option>
              <option value="1">管理者</option>
            </select>
          </div>
          {/* Button */}
          <div className="flex justify-end gap-2 ml-2 px-2 mt-2">
            <button
              type="submit"
              className="bg-blue-800 text-white px-6 py-[2px] rounded-[8px]"
            >
              保存
            </button>
            <button
              onClick={isAdduserToggle}
              className="bg-gray-600 text-white px-6 py-[2px] rounded-[8px]"
            >
              キャンセル
            </button>
          </div>
          {/* Button */}
        </form>
      )}
      {/* Edn Add User From */}

      {userLoading && !users ? (
        <SpinnerComp />
      ) : (
        <div className="user__list w-full w-12/12 flex flex-col gap-2 pt-8 text-md overflow-x-auto">
          {users &&
            users.value.map((user) => (
              <div
                key={user.id}
                className={
                  `w-full w-12/12 flex flex-col gap-2 justify-between py-4 px-2 rounded-md bg-blue-300 ` +
                  `${
                    editTarget && editTarget?.id === user.id
                      ? 'py-4 border-[2px] border-blue-700'
                      : 'border-[2px] border-white '
                  }`
                }
              >
                <div className="flex flex-col sm:flex-row gap-2">
                  {/* User ID/EMail */}
                  <input
                    className={
                      `w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800 ` +
                      `${
                        editTarget?.id === user.id
                          ? 'border-[1px] border-gray-300'
                          : ''
                      }`
                    }
                    onChange={(e) =>
                      editTarget && setUserIdEdit(e.target.value)
                    }
                    type="email"
                    value={
                      editTarget && editTarget?.id === user.id
                        ? userIdEdit
                        : user.user_id
                    }
                    disabled={editTarget?.id !== user.id ? 'disabled' : ''}
                  />
                  {/* End User ID/EMail */}

                  {/* User Name */}
                  <input
                    className={
                      `w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800 ` +
                      `${
                        editTarget?.id === user.id &&
                        'border-[1px] border-gray-300'
                      }`
                    }
                    onChange={(e) =>
                      editTarget && setUserNameEdit(e.target.value)
                    }
                    type="text"
                    value={
                      editTarget && editTarget?.id === user.id
                        ? userNameEdit
                        : user.user_name
                    }
                    disabled={editTarget?.id !== user.id ? 'disabled' : ''}
                  />
                  {/* End User Name */}

                  {/* User Department */}
                  <input
                    className={
                      `w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800 ` +
                      `${
                        editTarget?.id === user.id &&
                        'border-[1px] border-gray-300'
                      }`
                    }
                    onChange={(e) =>
                      editTarget && setUserDepartementEdit(e.target.value)
                    }
                    type="text"
                    value={
                      editTarget && editTarget?.id === user.id
                        ? userDepartmentEdit
                        : user.department
                    }
                    disabled={editTarget?.id !== user.id ? 'disabled' : ''}
                  />
                  {/* End User Department */}

                  {/* Auth */}
                  <select
                    name="auth"
                    id="auth"
                    className={
                      `w-full outline-none px-2 py-[2px] rounded-[8px] bg-white border border-gray-800 ` +
                      `${
                        editTarget?.id === user.id &&
                        'border-[1px] border-gray-300 cursor-pointer'
                      }`
                    }
                    value={
                      editTarget?.id === user.id ? userAuthEdit : user.auth
                    }
                    onChange={(e) =>
                      editTarget && setUserAuthEdit(e.target.value)
                    }
                    disabled={editTarget?.id !== user.id ? 'disabled' : ''}
                  >
                    <option value="0">スタッフ</option>
                    <option value="1">管理者</option>
                  </select>
                  {/* End Auth */}
                </div>

                {/* Action Button */}
                <div
                  className={`flex  ${
                    editTarget && editTarget?.id === user.id
                      ? 'justify-between'
                      : 'justify-end'
                  } gap-2 mx-[2px] text-sm`}
                >
                  {editTarget && editTarget?.id === user.id && (
                    <>
                      <button
                        type="button"
                        onClick={() => setIsUserDeleteModal(true)}
                        className="bg-red-600 text-white px-6 py-[2px] rounded-[8px]"
                      >
                        削除
                      </button>

                      {/* Modal Delete User */}
                      <Modal
                        isOpen={isUserDeleteModal}
                        shouldCloseOnOverlayClick={false}
                        onRequestClose={() => setIsUserDeleteModal(false)}
                        style={modalUserDelete}
                        contentLabel="Confirm delete"
                      >
                        <h1 className="font-semibold text-lg">
                          アカウントの削除
                        </h1>
                        <div className="w-full w-12/12 flex flex-col justify-center items-center sm:flex-row gap-2 my-8 overflow-x-auto">
                          <p className="text-lg">
                            {user.user_id}
                            アカウントを削除する ?
                          </p>
                        </div>

                        <div className="flex gap-2 justify-center items-center">
                          <button
                            onClick={() => userDeleteHandler(user.id)}
                            className="min-w-[120px] bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                            type="button"
                          >
                            確定する
                          </button>
                          <button
                            onClick={() => setIsUserDeleteModal(false)}
                            className="min-w-[120px] bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                            type="button"
                          >
                            キャンセル
                          </button>
                        </div>
                      </Modal>
                      {/* End Modal Delete User */}
                    </>
                  )}
                  <div className="flex gap-2">
                    {editTarget && editTarget.id === user.id ? (
                      <button
                        onClick={editUserhandler}
                        className="bg-blue-800 text-white px-6 py-[2px] rounded-[8px]"
                      >
                        保存
                      </button>
                    ) : (
                      <button
                        onClick={() => setEditTarget(user)}
                        className="bg-blue-800 text-white px-6 py-[2px] rounded-[8px]"
                      >
                        編集
                      </button>
                    )}
                    {editTarget && editTarget.id === user.id && (
                      <button
                        onClick={cancelEditHadnler}
                        className="bg-gray-800 text-white px-6 py-[2px] rounded-[8px]"
                      >
                        キャンセル
                      </button>
                    )}
                  </div>
                </div>
                {/* End Action Button */}
              </div>
            ))}
        </div>
      )}
    </div>
  )
}

const modalUserDelete = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    zIndex: 1000,
  },
  content: {
    maxHeight: '80vh',
    width: '80%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
    border: '1px solid black',
    background: '#fff',
  },
}

const customStylesUploadFail = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    zIndex: 1000,
  },
  content: {
    maxHeight: '80vh',
    width: '80%',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    position: 'relative',
    border: '1px solid black',
    background: '#fff',
  },
}

export default Users
